<script type="text/ecmascript-6">
    export default {
        props: {
            'policies': Object,
        },
        data() {
            return {
                baseUrl: Scoop.baseUrl,
            }
        },
        methods: {
            formatDate(date) {
                return new Date(date).toLocaleDateString();
            },
        },
    }
</script>